import React from "react";
import { Button, Dialog, useModals, useToasts } from "@gusarov-studio/rubik-ui";
import type { Database } from "../../../supabase";
import { fileTypes } from "../../../common/constants/fileTypes";
import { toasts } from "../../toasts";
import { useDeleteResourceMutation, useRestoreResourcesMutation } from "../api/resourcesApi";

interface DeleteResourceDilogContainerProps {
  resource: Database["public"]["Tables"]["resources"]["Row"];
}

const DeleteResourceDilogContainer: React.FC<DeleteResourceDilogContainerProps> = ({
  resource,
}) => {
  "use memo";
  const [deleteResource, { isLoading: isDeleting }] = useDeleteResourceMutation();
  const [restoreResources] = useRestoreResourcesMutation();
  const modals = useModals();
  const toastsManager = useToasts();

  const closeDialog = () => {
    modals.close();
  };

  const del = async () => {
    const { error, data } = await deleteResource({
      resourceId: resource.id,
    });

    if (!error) {
      const dataToRestore = data.map(({ id, ...otherData }) => ({
        id: id!,
        ...otherData,
      }));

      toastsManager.add(toasts.toastTypes.DELETE_RESOURCE, {
        resourceId: resource.id,
        onUndo: () => {
          restoreResources(dataToRestore);
        },
      });
    }

    closeDialog();
  };

  let captions;

  if (resource.type === fileTypes.PROMPT) {
    captions = {
      title: "Move to trash?",
      description: `"${resource.name}" will be deleted forever after 30 days`,
    };
  } else {
    captions = {
      title: "Move to trash?",
      description: `"${resource.name}" will be deleted forever after 30 days`,
    };
  }

  return (
    <Dialog.Root open={true}>
      <Dialog.Content width="400px">
        <Dialog.Decoration type="grid" />
        <Dialog.Close
          onClick={closeDialog}
          disabled={isDeleting}
        />
        <Dialog.Header>
          <Dialog.Title>{captions.title}</Dialog.Title>

          <Dialog.Description>{captions.description}</Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button
            appearance="outline"
            variant="secondary"
            size="40"
            onClick={closeDialog}
            disabled={isDeleting}
          >
            Cancel
          </Button>

          <Button
            variant="danger"
            size="40"
            onClick={del}
            disabled={isDeleting}
          >
            Move to trash
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export { DeleteResourceDilogContainer };
